<template>
  <LayoutContainer :props="props">
    <div class="kaer-rich-text" v-html="props.content" ref="richText"></div>
  </LayoutContainer>
</template>

<script>
export default {
  name: 'kaer-rich-text',
  props: {
    props: {
      content: String
    }
  },
  mounted() {
    // this.$refs.richText.addEventListener('click', (e) => {
    //   e.preventDefault();
    //   const node = e.path.find((val) => {
    //     return val.nodeName === 'A';
    //   });
    //   if (node && (node.attributes.href || {}).value) {
    //     this.adapt.open(node.attributes.href.value);
    //   }
    // });
  }
};
</script>

<style lang="less">
.kaer-rich-text {
  width: 100%;
  // overflow-y: auto;
  a {
    color: #3296fa;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  table,
  pre {
    margin: 10px 0;
    line-height: 1.5;
  }
  ul {
    list-style-type: disc;
  }
  ol {
    list-style-type: decimal;
  }
  ul,
  ol {
    margin: 20px 0 20px 30px;
    padding: 0;
  }

  blockquote {
    display: block;
    border-left: 16px solid #d0e5f2;
    padding: 10px 20px;
    margin: 20px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 6px;
    padding: 6px 10px;
    margin: 0 6px;
  }

  pre {
    code {
      display: block;
    }
  }

  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;

    td,
    th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 6px 10px;
      min-height: 60px;
    }

    th {
      border-bottom: 2px solid #ccc;
      text-align: center;
      background-color: #f1f1f1;
    }
  }

  &:focus {
    outline: none;
  }

  img {
    cursor: pointer;

    &:hover {
      box-shadow: 0 0 10px #333;
    }
  }

  .w-e-todo {
    margin: 0 0 0 40px;
    li {
      list-style: none;
      font-size: 1em;
      span:nth-child(1) {
        position: relative;
        left: -36px;

        input {
          position: absolute;
          top: 0.3em;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
